import * as React from 'react';

class HomeSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 26 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon home-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M11.5 15.5H6.5V20.5H11.5V15.5ZM10.5 19.5H7.5V16.5H10.5V19.5ZM25.96 12.7L22.46 0.700018C22.3959 0.496031 22.268 0.317978 22.0952 0.191992C21.9224 0.0660063 21.7138 -0.00127644 21.5 1.83428e-05H4.5C4.28363 1.83428e-05 4.0731 0.070196 3.9 0.200018C3.7269 0.32984 3.60058 0.512303 3.54 0.720019L0.04 12.72C-0.00346861 12.8691 -0.0116406 13.0262 0.0161305 13.1789C0.0439016 13.3316 0.106853 13.4758 0.2 13.6C0.293147 13.7242 0.413931 13.825 0.552787 13.8944C0.691642 13.9639 0.844755 14 1 14H3V21.5C3 21.8978 3.15804 22.2794 3.43934 22.5607C3.72064 22.842 4.10218 23 4.5 23H21.5C21.8978 23 22.2794 22.842 22.5607 22.5607C22.842 22.2794 23 21.8978 23 21.5V14H25C25.157 13.9977 25.3112 13.9585 25.4501 13.8855C25.5891 13.8126 25.709 13.7079 25.8 13.58C25.8931 13.4558 25.9561 13.3116 25.9839 13.1589C26.0116 13.0062 26.0035 12.8491 25.96 12.7ZM19 22H16V16.5H19V22ZM22 21.5C22 21.6326 21.9473 21.7598 21.8536 21.8536C21.7598 21.9473 21.6326 22 21.5 22H20V15.5H15V22H4.5C4.36739 22 4.24021 21.9473 4.14645 21.8536C4.05268 21.7598 4 21.6326 4 21.5V14H22V21.5ZM1 13L4.5 1.00002H21.5L25 13H1Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default HomeSvg;
